import { ContactSlugEnum } from 'src/shared/enums/contact-fields-enum'

// NOTE: These are the default contact fields. Other fields are custom fields.
export const defaultContactFieldsSlugs = [
  ContactSlugEnum.Email,
  ContactSlugEnum.FirstName,
  ContactSlugEnum.Surname,
  ContactSlugEnum.PhoneNumber,
  ContactSlugEnum.CompanyName,
  ContactSlugEnum.Country,
  ContactSlugEnum.State,
  ContactSlugEnum.City,
  ContactSlugEnum.Neighborhood,
  ContactSlugEnum.StreetAddress,
  ContactSlugEnum.StreetNumber,
  ContactSlugEnum.Postcode,
  ContactSlugEnum.TaxNumber,
]
